import React from 'react';
import PropTypes from 'prop-types';
import MasterREITsTable from './MasterREITsTable';

const MasterREITComponent = ({
  reitsData,
  handleEditButtonClick,
  handleDeleteButtonClick,
  handleGridColumnStateChange,
  handleGridChanges,
  gridColumnState,
  currentUserIsSysAdmin,
  currentUserIsEngAdmin,
}) => {
  return (
    <div>
      <div>
        <MasterREITsTable
          reitsData={reitsData}
          handleEditButtonClick={handleEditButtonClick}
          handleDeleteButtonClick={handleDeleteButtonClick}
          handleGridColumnStateChange={handleGridColumnStateChange}
          handleGridChanges={handleGridChanges}
          gridColumnState={gridColumnState}
          currentUserIsSysAdmin={currentUserIsSysAdmin}
          currentUserIsEngAdmin={currentUserIsEngAdmin}
        />
      </div>
    </div>
  );
};

MasterREITComponent.propTypes = {
  reitsData: PropTypes.array,
  handleEditButtonClick: PropTypes.func.isRequired,
  handleDeleteButtonClick: PropTypes.func.isRequired,
  handleGridColumnStateChange: PropTypes.func.isRequired,
  handleGridChanges: PropTypes.func.isRequired,
  gridColumnState: PropTypes.object.isRequired,
  currentUserIsSysAdmin: PropTypes.bool.isRequired,
  currentUserIsEngAdmin: PropTypes.bool.isRequired,
};

export default MasterREITComponent;
